// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s__G","col":"styles_col__3fOj8"};